import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "warpit_icon_air-quality" }, null, -1)
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "numOfBar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_InfinityScroll = _resolveComponent("InfinityScroll")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_InfinityScroll, {
      onLoadNextPage: _ctx.loadAirQualitySensors,
      data: _ctx.sensors
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sensors.data, (sensor) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: sensor.id,
            to: { name: 'AirQualityById', params: { id: sensor.id } },
            class: "flex customTabLink",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('sidebar-toggled')))
          }, {
            default: _withCtx(() => [
              _hoisted_1,
              _createElementVNode("span", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, _toDisplayString(sensor.name), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(["progressBar", _ctx.getSensorColorClass(parseInt(sensor.measurements?.index))])
                }, [
                  _createVNode(_component_ProgressBar, {
                    value: sensor.measurements?.index / 2
                  }, null, 8, ["value"]),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(sensor.measurements?.index), 1)
                ], 2)
              ])
            ]),
            _: 2
          }, 1032, ["to"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["onLoadNextPage", "data"])
  ]))
}